import { observer } from "mobx-react"
import { ProSchemaForm } from "polaris-enhance"

import stores from "@/stores"

const SchemaFormPannel = () => {
  return (
    <ProSchemaForm
      schemas={stores.CommonStore.temporarySchemas || []}
      value={stores.CommonStore.temporarySchemaForm || {}}
      onChange={(value) => {
        stores.CommonStore.setTemporarySchemaForm(value)
      }}
      loading={stores.CommonStore.temporarySchemaFormLoading}
    />
  )
}
export default observer(SchemaFormPannel)
